export type NewsCategory = "新闻" | "预告" | "评论" | "采访";

export interface NewsBlock {
  type: "paragraph" | "h2" | "quote" | "image";
  text?: string;
  src?: string;
  caption?: string;
}

export interface NewsItem {
  id: string;
  title: string;
  category: NewsCategory;
  date: string;
  author: string;
  cover: string;
  excerpt: string;
  relatedMovieId?: string;
  blocks: NewsBlock[];
}

export const newsList: NewsItem[] = [
  {
    id: "news-01",
    title: "《长夜将尽》口碑逆袭：一部慢下来的悬疑片如何戳中观众",
    category: "评论",
    date: "2025-10-09",
    author: "影评人 · 沈渡",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20night%20city%20street%20in%20light%20rain%20with%20warm%20amber%20streetlights%20and%20a%20lone%20figure%20walking%2C%20moody%20editorial%20photography%2C%20deep%20charcoal%20tones%2C%20film%20grain%2C%20no%20text&width=800&height=500&seq=fl-news-01&orientation=landscape",
    excerpt:
      "上映第三周，《长夜将尽》凭口碑完成票房逆跌。它放弃了类型片惯用的快切与反转轰炸，把大部分时间留给了沉默、雨声和两个人之间说不出口的裂缝。",
    relatedMovieId: "movie-01",
    blocks: [
      {
        type: "paragraph",
        text: "《长夜将尽》不是一部急着把答案交给观众的悬疑片。开场二十分钟，镜头几乎没有离开过那条被雨淋透的旧街，人物走路、抽烟、抬头看一扇亮着灯的窗户，什么也没发生，但什么都发生了。",
      },
      {
        type: "h2",
        text: "把节奏交还给环境",
      },
      {
        type: "paragraph",
        text: "导演顾明川在采访中提到，他刻意减少了配乐的使用，让雨声、脚步声和远处的汽笛成为主要的情绪来源。这种做法在商业类型片里并不讨巧，却让整部电影的压迫感变得具体——它不是突然吓你一跳，而是让你在两个小时里一直无法放松。",
      },
      {
        type: "image",
        src: "https://readdy.ai/api/search-image?query=Rain%20soaked%20old%20city%20alley%20at%20night%20with%20warm%20lamplight%20reflecting%20on%20cobblestone%2C%20atmospheric%20cinematic%20still%2C%20deep%20charcoal%20and%20amber%20palette%2C%20no%20text&width=900&height=600&seq=fl-news-01-inline&orientation=landscape",
        caption: "影片大量使用实景夜戏，雨几乎贯穿全片。",
      },
      {
        type: "h2",
        text: "真相之外，更在乎人",
      },
      {
        type: "paragraph",
        text: "与很多同类作品不同，《长夜将尽》在最后并没有给出一个痛快淋漓的解释。它更关心的是：当一个人知道自己信任的人曾经做错事，他还愿不愿意继续把日子过下去。这个问题没有标准答案，也正是影片最有力的地方。",
      },
      {
        type: "quote",
        text: "「长夜将尽」不是一个结局，而是一种提醒——天会亮，但有些事不会自动消失。",
      },
    ],
  },
  {
    id: "news-02",
    title: "秋季剧集前瞻：五部值得放进片单的华语新剧",
    category: "新闻",
    date: "2025-10-07",
    author: "编辑部 · 林然",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20autumn%20evening%20living%20room%20with%20a%20glowing%20television%2C%20knitted%20blanket%20and%20a%20cup%20of%20tea%2C%20soft%20amber%20light%2C%20cozy%20editorial%20interior%20photography%2C%20no%20text&width=800&height=500&seq=fl-news-02&orientation=landscape",
    excerpt:
      "从港口悬疑到小城美食，从古装家族到都市群像，这一季的华语剧集在题材上明显更敢走。我们挑出五部最值得留意的作品。",
    relatedMovieId: "tv-01",
    blocks: [
      {
        type: "paragraph",
        text: "今年的秋季档没有出现单一爆款垄断讨论的局面，反而是几部体量不大的作品各自吸引了一批稳定观众。题材分散，但共同点是：都愿意把人物写得更具体一点。",
      },
      { type: "h2", text: "《雾港迷踪》：把类型做到极致" },
      {
        type: "paragraph",
        text: "作为本季关注度最高的悬疑剧，它几乎把所有预算都花在了氛围与表演上。港口、浓雾、集装箱堆场构成了一个封闭的舞台，二十四集里有三分之二的时间在下雨。",
      },
      { type: "h2", text: "《小城食光》：十二碗面的温柔" },
      {
        type: "paragraph",
        text: "每集一位客人，每集一碗面。它不急于讲大道理，只是安静地把普通人的疲惫端上桌。看完之后最想做的事，是下楼吃一碗热汤面。",
      },
      {
        type: "image",
        src: "https://readdy.ai/api/search-image?query=Steaming%20bowl%20of%20noodles%20on%20a%20rustic%20wooden%20table%20with%20warm%20lantern%20light%2C%20cozy%20food%20photography%2C%20amber%20and%20cream%20tones%2C%20no%20text&width=900&height=600&seq=fl-news-02-inline&orientation=landscape",
        caption: "美食剧的镜头语言，正在变得越来越克制。",
      },
      {
        type: "paragraph",
        text: "另外三部《京华旧梦》《灯火人间》《数据深渊》分别代表古装、都市与科幻三条路线，具体表现还要看后续更新。可以确定的是，观众对「慢一点、真一点」的耐心，比行业想象中更多。",
      },
    ],
  },
  {
    id: "news-03",
    title: "《云上列车》发布正式预告，黄昏列车驶过云海",
    category: "预告",
    date: "2025-10-05",
    author: "编辑部 · 顾小满",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20sea%20of%20clouds%20at%20golden%20hour%20with%20a%20vintage%20train%20crossing%20the%20sky%2C%20warm%20peach%20and%20amber%20tones%2C%20soft%20brushwork%2C%20dreamy%20atmosphere%2C%20no%20text&width=800&height=500&seq=fl-news-03&orientation=landscape",
    excerpt:
      "两分十二秒的预告几乎没有台词，只靠一列穿过云层的火车和一段钢琴主题，把「告别」两个字讲完了。",
    relatedMovieId: "movie-02",
    blocks: [
      {
        type: "paragraph",
        text: "新见遥执导的动画长片《云上列车》今日发布正式预告。预告片从一片翻涌的云海开始，镜头跟随一列老式列车上升，车厢里的乘客各自望着窗外，没有人说话。",
      },
      {
        type: "h2",
        text: "音乐先行，台词退后",
      },
      {
        type: "paragraph",
        text: "整支预告只出现了三句对白，其余情绪全部由钢琴与弦乐承担。制作方表示，影片希望让观众先感受到「舍不得」，再慢慢理解角色为什么舍不得。",
      },
      {
        type: "image",
        src: "https://readdy.ai/api/search-image?query=Inside%20a%20vintage%20train%20carriage%20with%20warm%20sunset%20light%20through%20windows%20and%20empty%20seats%2C%20anime%20illustration%20style%2C%20soft%20peach%20and%20amber%20tones%2C%20no%20text&width=900&height=600&seq=fl-news-03-inline&orientation=landscape",
        caption: "预告中车厢内的光影处理，延续了导演一贯的手绘质感。",
      },
      {
        type: "paragraph",
        text: "影片已定档 8 月 15 日，片长 116 分钟。官方同时确认，国内将同步引进原版与配音版本。",
      },
    ],
  },
  {
    id: "news-04",
    title: "专访顾明川：我不想拍一部让人「爽」的悬疑片",
    category: "采访",
    date: "2025-10-02",
    author: "记者 · 何岸",
    cover:
      "https://readdy.ai/api/search-image?query=Director%20chair%20and%20monitor%20on%20a%20rainy%20night%20film%20set%2C%20warm%20amber%20work%20lights%20against%20deep%20blue%20grey%20darkness%2C%20cinematic%20behind%20the%20scenes%20photography%2C%20no%20text&width=800&height=500&seq=fl-news-04&orientation=landscape",
    excerpt:
      "「观众不需要我替他们愤怒，他们需要的是被认真对待。」顾明川聊了聊这部片子的雨、沉默，以及为什么删掉了最后一场戏。",
    relatedMovieId: "movie-01",
    blocks: [
      {
        type: "paragraph",
        text: "采访约在剪接室，桌上摊着几页被划得很乱的分场表。顾明川说，这部电影剪了十一个版本，最后留下的这个，是「最不热闹」的一版。",
      },
      { type: "h2", text: "关于雨" },
      {
        type: "paragraph",
        text: "「雨不是为了好看。」他说，「是因为雨会让所有声音变钝，人说话就得靠近一点，靠近了，谎话就难讲。」为了等一场合适的雨，剧组在港口多待了十七天。",
      },
      { type: "h2", text: "关于被删掉的那场戏" },
      {
        type: "paragraph",
        text: "原片结尾有一场很长的独白，解释了所有动机。试映之后，顾明川把它整段删掉了。「解释完，观众就轻松了。我不想让他们轻松。」",
      },
      {
        type: "quote",
        text: "「一个故事真正的结束，是观众走出影院之后还在想它。」",
      },
      {
        type: "image",
        src: "https://readdy.ai/api/search-image?query=Stack%20of%20marked%20screenplay%20pages%20and%20a%20pen%20on%20a%20wooden%20desk%20under%20warm%20lamp%20light%2C%20editorial%20close%20up%2C%20amber%20tones%2C%20no%20text&width=900&height=600&seq=fl-news-04-inline&orientation=landscape",
        caption: "十一个剪辑版本，留下了最安静的那个。",
      },
      {
        type: "paragraph",
        text: "谈及下一部作品，他只说了一句：「想拍一个白天的故事。」",
      },
    ],
  },
  {
    id: "news-05",
    title: "《雾港迷踪》开分 9.0，国产悬疑剧的天花板又抬高了",
    category: "评论",
    date: "2025-09-28",
    author: "剧评人 · 白露",
    cover:
      "https://readdy.ai/api/search-image?query=Foggy%20industrial%20harbor%20at%20dawn%20with%20container%20cranes%20and%20a%20single%20sodium%20lamp%2C%20cold%20grey%20mist%20with%20warm%20orange%20accent%2C%20cinematic%20mood%2C%20no%20text&width=800&height=500&seq=fl-news-05&orientation=landscape",
    excerpt:
      "它没有把观众当傻子。线索给得克制，人物动机站得住，二十四集几乎没有废戏——这已经足够值得一次高分。",
    relatedMovieId: "tv-01",
    blocks: [
      {
        type: "paragraph",
        text: "国产悬疑剧最常见的问题不是不够烧脑，而是为了让观众「看懂」，反复解释、反复闪回，最后把悬念磨成了说明书。《雾港迷踪》难得地相信观众。",
      },
      { type: "h2", text: "克制，是最大的诚意" },
      {
        type: "paragraph",
        text: "前六集只讲了一件事：港口发现了什么。所有信息都通过人物对话与现场细节给出，观众需要自己拼。这种处理方式让追剧变成了一件需要专注的事，也让反转真正有重量。",
      },
      {
        type: "image",
        src: "https://readdy.ai/api/search-image?query=Detective%20case%20board%20with%20photos%20and%20red%20string%20in%20a%20dim%20office%2C%20warm%20desk%20lamp%20light%2C%20investigation%20atmosphere%2C%20cinematic%20close%20up%2C%20no%20text&width=900&height=600&seq=fl-news-05-inline&orientation=landscape",
        caption: "剧中的案件板，几乎每一集都会增加新的细节。",
      },
      {
        type: "paragraph",
        text: "当然，它并非完美。中段节奏偶有拖沓，个别配角的功能性过强。但在一部追求类型完成度的作品里，这些瑕疵不足以掩盖它的野心。",
      },
    ],
  },
  {
    id: "news-06",
    title: "《向往的山野》第二季官宣，这一季他们要去种水稻",
    category: "新闻",
    date: "2025-09-24",
    author: "编辑部 · 陶然",
    cover:
      "https://readdy.ai/api/search-image?query=Terraced%20rice%20paddies%20in%20a%20misty%20mountain%20valley%20at%20sunrise%2C%20warm%20golden%20light%2C%20lush%20green%20terraces%2C%20serene%20documentary%20landscape%20photography%2C%20no%20text&width=800&height=500&seq=fl-news-06&orientation=landscape",
    excerpt:
      "节目组确认第二季将前往南方梯田，常驻嘉宾需要完整经历一次插秧到收割的全过程，拍摄周期长达四个月。",
    relatedMovieId: "variety-01",
    blocks: [
      {
        type: "paragraph",
        text: "在第一季的蔬菜之后，《向往的山野》把难度升级到了水稻。节目组透露，这一季的拍摄横跨四个月，嘉宾需要真正参与插秧、田间管理与收割。",
      },
      {
        type: "h2",
        text: "慢综艺的「慢」是有代价的",
      },
      {
        type: "paragraph",
        text: "四个月的拍摄周期在综艺行业里几乎是奢侈的。总导演吴桐表示，只有真的待够时间，才能拍到天气、虫害和收成这些无法设计的东西。",
      },
      {
        type: "image",
        src: "https://readdy.ai/api/search-image?query=Farmer%20hands%20planting%20rice%20seedlings%20in%20flooded%20paddy%20water%20at%20golden%20hour%2C%20close%20up%20documentary%20photography%2C%20warm%20amber%20and%20green%20tones%2C%20no%20text&width=900&height=600&seq=fl-news-06-inline&orientation=landscape",
        caption: "第二季将完整呈现一次水稻的生长周期。",
      },
      {
        type: "paragraph",
        text: "第二季预计明年春季上线，常驻阵容保持三人不变，每期会有一位飞行嘉宾参与农活。",
      },
    ],
  },
  {
    id: "news-07",
    title: "《归途有风》重映：一部关于沉默的电影，为什么值得再看",
    category: "评论",
    date: "2025-09-19",
    author: "影评人 · 沈渡",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20rural%20road%20in%20late%20autumn%20with%20golden%20poplar%20trees%20and%20soft%20hazy%20sunlight%2C%20warm%20cream%20and%20rust%20palette%2C%20nostalgic%20cinematic%20landscape%2C%20no%20text&width=800&height=500&seq=fl-news-07&orientation=landscape",
    excerpt:
      "一年后重看，会发现它真正的力量不在那些爆发的瞬间，而在两个人在服务区买水时，谁也没有先开口的那三十秒。",
    relatedMovieId: "movie-03",
    blocks: [
      {
        type: "paragraph",
        text: "《归途有风》上映时被不少观众评价「太安静」。一年后重映，我反而觉得这份安静是它最大的勇气。",
      },
      { type: "h2", text: "沉默也是一种台词" },
      {
        type: "paragraph",
        text: "父女俩在车上几乎没有完整对话，更多时候是收音机、导航提示和窗外的风声。导演李蔓把大量镜头留给了空白，让观众自己去填补那些没说出口的话。",
      },
      {
        type: "quote",
        text: "有些和解不需要拥抱，只需要有人愿意多绕两百公里送你回家。",
      },
      {
        type: "image",
        src: "https://readdy.ai/api/search-image?query=Highway%20rest%20area%20at%20dusk%20with%20a%20parked%20old%20car%20and%20warm%20vending%20machine%20light%2C%20soft%20autumn%20tones%2C%20nostalgic%20cinematic%20still%2C%20no%20text&width=900&height=600&seq=fl-news-07-inline&orientation=landscape",
        caption: "服务区那场戏，全片台词不超过十句。",
      },
      {
        type: "paragraph",
        text: "重映版本增加了十分钟未公开片段，主要集中在母亲这一角色上，让人物的选择更容易被理解。",
      },
    ],
  },
  {
    id: "news-08",
    title: "《潮汐之下》定档 6 月 13 日，尹在勋新作聚焦海滨失踪案",
    category: "新闻",
    date: "2025-09-15",
    author: "编辑部 · 顾小满",
    cover:
      "https://readdy.ai/api/search-image?query=Fishing%20harbor%20at%20blue%20hour%20with%20fog%20over%20dark%20water%20and%20old%20boats%2C%20warm%20dock%20light%20against%20cold%20teal%20water%2C%20moody%20cinematic%20wide%20shot%2C%20no%20text&width=800&height=500&seq=fl-news-08&orientation=landscape",
    excerpt:
      "导演尹在勋新片确定引进，影片以一场十五年前的海难为起点，讲述一位女警探在家乡调查失踪案的故事。",
    relatedMovieId: "movie-06",
    blocks: [
      {
        type: "paragraph",
        text: "《潮汐之下》今日确认定档 6 月 13 日。这是尹在勋继《雾中来客》后时隔三年的新作，依旧由他自编自导。",
      },
      {
        type: "h2",
        text: "海、雾与记忆",
      },
      {
        type: "paragraph",
        text: "影片在韩国西海岸实地拍摄，全片超过一半的镜头与水有关。尹在勋表示，海是他理解「记忆」最直接的媒介——潮水退去，东西才会露出来。",
      },
      {
        type: "image",
        src: "https://readdy.ai/api/search-image?query=Wet%20sandy%20beach%20at%20low%20tide%20with%20footprints%20and%20scattered%20driftwood%2C%20cold%20blue%20grey%20dawn%20light%2C%20quiet%20mysterious%20cinematic%20still%2C%20no%20text&width=900&height=600&seq=fl-news-08-inline&orientation=landscape",
        caption: "退潮线是影片反复出现的视觉母题。",
      },
      {
        type: "paragraph",
        text: "主演朴镇宇与李恩彩均为首次与尹在勋合作，影片片长 132 分钟。",
      },
    ],
  },
  {
    id: "news-09",
    title: "《小城食光》导演周梧：我想拍的是一碗面的时间",
    category: "采访",
    date: "2025-09-10",
    author: "记者 · 何岸",
    cover:
      "https://readdy.ai/api/search-image?query=Small%20night%20market%20food%20stall%20with%20steaming%20pots%20and%20warm%20hanging%20lanterns%2C%20cozy%20street%20photography%2C%20rich%20amber%20tones%2C%20no%20text&width=800&height=500&seq=fl-news-09&orientation=landscape",
    excerpt:
      "「一碗面从下锅到端上桌，大概三分钟。这三分钟里，客人不说话，我也不说话，那是最好的部分。」",
    relatedMovieId: "tv-07",
    blocks: [
      {
        type: "paragraph",
        text: "周梧的剧里几乎没有强情节。他把镜头对准灶台、蒸汽、客人的手和吃面时的沉默，用二十集讲了一条老街的日常。",
      },
      { type: "h2", text: "食物的作用是让人坐下来" },
      {
        type: "paragraph",
        text: "「我不太会拍美食特写。」周梧笑着说，「我更想拍人坐下来之后，那几分钟放松的样子。」为此他要求所有食物都必须是真的，演员也必须真的吃完。",
      },
      {
        type: "quote",
        text: "「一个人愿意坐下来吃碗面，说明他还想继续过下去。」",
      },
      {
        type: "image",
        src: "https://readdy.ai/api/search-image?query=Empty%20wooden%20stool%20and%20counter%20in%20a%20small%20noodle%20shop%20at%20dusk%2C%20warm%20steam%20and%20lantern%20glow%2C%20quiet%20nostalgic%20cinematic%20still%2C%20no%20text&width=900&height=600&seq=fl-news-09-inline&orientation=landscape",
        caption: "剧中的面馆取景于一座真实营业了三十年的老店。",
      },
      {
        type: "paragraph",
        text: "第二季已在筹备中，周梧说想换一个城市，但「还是只做十二碗面」。",
      },
    ],
  },
  {
    id: "news-10",
    title: "从《山海之间》看自然纪录片的叙事转向",
    category: "评论",
    date: "2025-09-04",
    author: "特约撰稿 · 竹内遥",
    cover:
      "https://readdy.ai/api/search-image?query=Coastal%20mountain%20range%20in%20soft%20morning%20mist%20with%20layers%20of%20pale%20golden%20light%20over%20the%20water%2C%20minimal%20serene%20documentary%20landscape%2C%20no%20text&width=800&height=500&seq=fl-news-10&orientation=landscape",
    excerpt:
      "当旁白越来越少，镜头越来越长，自然纪录片正在把解释权交还给观众。这或许是它重新变得好看的原因。",
    relatedMovieId: "movie-07",
    blocks: [
      {
        type: "paragraph",
        text: "《山海之间》最特别的地方，是它几乎不解释。没有拟人化的旁白，没有戏剧化的配乐，只有三年时间里积累下来的素材。",
      },
      { type: "h2", text: "少一点，反而更多" },
      {
        type: "paragraph",
        text: "当镜头愿意在一个潮池上停留四分钟，观众才开始注意到水面下正在发生的事。这种耐心，在快节奏的内容环境里显得格外珍贵。",
      },
      {
        type: "image",
        src: "https://readdy.ai/api/search-image?query=Tide%20pool%20with%20small%20sea%20creatures%20and%20reflections%20of%20morning%20sky%2C%20warm%20golden%20light%2C%20detailed%20nature%20documentary%20photography%2C%20no%20text&width=900&height=600&seq=fl-news-10-inline&orientation=landscape",
        caption: "潮池段落全长四分钟，没有任何解说。",
      },
      {
        type: "paragraph",
        text: "当然，这种表达方式对观众的专注度提出了要求。但真正好的自然影像，从来不是背景音。",
      },
    ],
  },
  {
    id: "news-11",
    title: "《推理之夜》新一季回归，案件结构全面升级",
    category: "预告",
    date: "2025-08-28",
    author: "编辑部 · 陶然",
    cover:
      "https://readdy.ai/api/search-image?query=Dim%20elegant%20mansion%20room%20lit%20by%20candles%20with%20scattered%20clues%20and%20an%20old%20key%20on%20a%20table%2C%20warm%20amber%20glow%2C%20mystery%20show%20cinematic%20still%2C%20no%20text&width=800&height=500&seq=fl-news-11&orientation=landscape",
    excerpt:
      "新一季将采用「双层案件」结构：玩家在破解主案的同时，还需要判断彼此之中谁在说谎。",
    relatedMovieId: "variety-06",
    blocks: [
      {
        type: "paragraph",
        text: "《推理之夜》公布新一季玩法：每期设置一个主案件与一条隐藏支线，玩家必须在有限时间内同时完成两条线索的推理。",
      },
      {
        type: "image",
        src: "https://readdy.ai/api/search-image?query=Candlelit%20table%20with%20old%20letters%2C%20keys%20and%20a%20magnifying%20glass%2C%20warm%20amber%20light%20and%20deep%20shadow%2C%20mystery%20game%20still%20life%2C%20no%20text&width=900&height=600&seq=fl-news-11-inline&orientation=landscape",
        caption: "新一季的道具细节比上一季更复杂。",
      },
      {
        type: "paragraph",
        text: "固定阵容保持不变，节目将于下月首播，每期时长约 100 分钟。",
      },
    ],
  },
  {
    id: "news-12",
    title: "专访《声音的旅行》：把舞台拆掉之后，歌声更清楚了",
    category: "采访",
    date: "2025-08-20",
    author: "记者 · 林然",
    cover:
      "https://readdy.ai/api/search-image?query=Singer%20with%20a%20guitar%20performing%20outdoors%20on%20a%20cliff%20at%20sunset%2C%20warm%20orange%20backlight%20and%20wind%2C%20intimate%20cinematic%20music%20photography%2C%20no%20text&width=800&height=500&seq=fl-news-12&orientation=landscape",
    excerpt:
      "没有返送、没有灯光秀，只有风和海。节目总导演叶南聊了聊，为什么要把歌手带到没有舞台的地方去唱。",
    relatedMovieId: "variety-02",
    blocks: [
      {
        type: "paragraph",
        text: "《声音的旅行》最新一期把演出地点选在了一处海崖。没有观众席，只有十几位当地渔民站在几米外听。",
      },
      { type: "h2", text: "环境是最好的编曲" },
      {
        type: "paragraph",
        text: "叶南说，一旦撤掉舞台，歌手就必须重新学习怎么用声音填满空间。「风会吃掉高频，海浪会打乱节奏，这些都骗不了人。」",
      },
      {
        type: "image",
        src: "https://readdy.ai/api/search-image?query=Audio%20recording%20equipment%20and%20a%20microphone%20stand%20on%20a%20windy%20cliff%20overlooking%20the%20sea%20at%20golden%20hour%2C%20warm%20amber%20tones%2C%20documentary%20photography%2C%20no%20text&width=900&height=600&seq=fl-news-12-inline&orientation=landscape",
        caption: "户外收音成为节目最大的技术挑战。",
      },
      {
        type: "paragraph",
        text: "节目下一站将前往西北戈壁，叶南说那里「几乎没有任何反射声」，是另一种极端。",
      },
    ],
  },
];